module.exports = __webpack_public_path__ + "img/gray-location-linear-20x20.fd5da43d.svg";